/**
 * Rider requirements and role details, shared by /jobs and /riders so the two
 * pages can never disagree. Requirements are displayed only; applicants bring
 * the documents when the team contacts them, never through the website.
 */

export const RIDER_REQUIREMENTS = [
  "Your own motorcycle, with its current OR/CR",
  "A valid driver's license",
  "A valid government-issued ID",
  "A smartphone (Android or iPhone) with mobile data",
];

export const RIDER_DUTIES = [
  "Pick up food, grocery, and pharmacy orders from local stores",
  "Pay the store for the order, then collect the total on delivery (GCash orders are already paid)",
  "Run Pasugo errands: buy-and-deliver, or pick up and drop off an item",
  "Keep customers updated through the PABS rider app",
];

export const RIDER_PERKS = [
  "Go online when you choose",
  "Deliveries, Pasugo errands, and Angkas rides in one app",
  "Earnings, invoices, and dues tracked in the rider app",
];

/* How the rider app actually works; shown so nobody is surprised later. */
export const RIDER_TERMS = [
  "You work as an independent rider partner, not an employee",
  "Keep a small balance in your in-app wallet to accept jobs",
  "Depending on your rate, PABS earns either a commission per trip or a fixed weekly due",
  "Stay active: riders with no completed delivery in 7 days may be suspended",
];

/* The in-app verification step, after the in-person meeting. */
export const RIDER_VERIFICATION =
  "In the rider app you'll also upload a valid ID and a profile photo. PABS verifies you, usually within 72 hours, before you can accept bookings.";

export const RIDER_AREA = "Camiguin";

/* The five Camiguin municipalities, all currently open in the app (its
   temporarily-closed list is empty). Used by the Town dropdowns. */
export const CAMIGUIN_TOWNS = ["Mambajao", "Mahinog", "Guinsiliban", "Sagay", "Catarman"];
